import React from "react";
import classNames from "classnames";
import { useConfig } from "../_util/config-context";
import { SearchBox, SearchBoxProps } from "../searchbox";

export function ListSearchBox({ className, ...restProps }: SearchBoxProps) {
  const { classPrefix } = useConfig();
  return (
    <SearchBox
      iconPlacement="start"
      className={classNames(`${classPrefix}-list__search-box`, className)}
      simple
      {...restProps}
    />
  );
}
